import React from 'react'
import { AppBar, Toolbar, Typography, withStyles, WithStyles } from '@zn-material-ui'
import { Login } from '@services/api'
import Store from 'store'
import { withSnackbar, withSnackbarProps } from 'notistack'
import { last, split } from 'lodash'
import { createHashHistory } from 'history'
import { toLogin, isPingAn, getOriginFromUrl, toLoginOutTo37, enterpriseIdSqList, getCancelUrl,
  enterpriseIdGZList, loginOutToManage
} from '@utils'
import styles from './AppBar'
import { DropDownList } from '@components/Select'
import DataTracker from '@common/dataTracker'
import ConfirmDialog from '@components/Dialog'
import SearchBox from './SearchBox'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import { RouteComponentProps } from 'react-router'
import UserStore from '@stores/UserStore'
import { IUserStore } from '@stores/UserStore'
import { IExamStore } from '@stores/ExamStore'
import { RouterUtil } from '@utils/router'
import { ExamStage } from '@const/exam'
import { NEED_BAND_STORAGE_KEY } from '@const/login'
import { transform } from '@utils/intl_lang'
// zn-i18n-disable-next-line
const DATATREACKER_KEY = '01Web-智门户首页'
const DROP_DOWN_LIST = [
  // '我的设置'
  { title: transform('my_setting'), value: '0' },
  // '退出登录'
  { title: transform('logout'), value: '1' },
]

export interface IProps
  extends withSnackbarProps,
  WithStyles<typeof styles>,
  RouteComponentProps {
  pushMessage?: string
  HomeState?: any
  UserStore?: IUserStore
  ExamStore?: IExamStore
  Search?: any
}
export interface IState {
  open: boolean
}
@inject('UserStore', 'HomeState', 'ExamStore', 'Search')
@observer
class PrimarySearchAppBar extends React.Component<IProps, IState> {
  public state = {
    open: false,
  }

  // 因为考试页比较特殊，在考试页跳转需要从url上获取origin
  private getOrigin = () => {
    if (this.isExamDetailPage()) {
      return getOriginFromUrl() || ''
    }
    return ''
  }

  private goToHomePage = () => {
    this.goToPage('/home/homePage')
  }

  private goToMyNews = () => {
    this.goToPage('/home/MyNews')
  }

  private goCircle = () => {
    // 1 竖版e祺学
    this.goToPage('/home/myTopic/1')
  }

  private goMyOrder = () => {
    this.goToPage(`/home/myOrder?trainingItemId=${Store.get('trainingItemId')}`)
  }

  private goToPage = (url: string) => {
    const { ExamStore } = this.props
    const origin = this.getOrigin()
    if (origin) {
      if (ExamStore!.examStage === ExamStage.exam) {
        // '考试中途不允许退出'
        global.$message(transform('not_allow_quit'))
      } else {
        const prefix =
          origin.indexOf('localhost') > -1 ? origin : origin + '/znWeb/znPortal'
        location.href = `${prefix}/#${url}`
      }
    } else {
      this.props.history.push(url)
    }
  }

  private handleProfileMenuOpen = () => {
    const dataTracker = {
      category: DATATREACKER_KEY,
      // zn-i18n-disable-next-line
      label: '0104Web-点击头像',
      mapkv: {
        // zn-i18n-disable-next-line
        from: '01Web-智门户首页',
      },
    }
    DataTracker.singleTrackEvent(dataTracker)
    this.setState({ open: true })
  }

  private toWallet = () => {
    const dataTracker = {
      category: DATATREACKER_KEY,
      // zn-i18n-disable-next-line
      label: '0102Web-查看钱包',
      mapkv: {
        // zn-i18n-disable-next-line
        from: '01Web-智门户首页',
      },
    }
    DataTracker.singleTrackEvent(dataTracker)

    const origin = this.getOrigin()
    window.open(`${origin}/znWeb/moneyBag.html`, '_blank')
  }

  private linkMySetting = () => {
    const dataTracker = {
      category: DATATREACKER_KEY,
      // zn-i18n-disable-next-line
      label: '0106Web-我的设置',
      mapkv: {
        // zn-i18n-disable-next-line
        from: '01Web-智门户首页',
      },
    }
    DataTracker.singleTrackEvent(dataTracker)

    this.goToPage('/home/mySetting')
  }

  private logout = () => {
    if (
      this.isExamDetailPage() &&
      this.props.ExamStore!.examStage === ExamStage.exam
    ) {
      // '考试中途不允许退出'
      global.$message(transform('not_allow_quit'))
      return
    }

    const dataTracker = {
      category: DATATREACKER_KEY,
      // zn-i18n-disable-next-line
      label: '0107Web-退出登录',
      mapkv: {
        // zn-i18n-disable-next-line
        from: '01Web-智门户首页',
      },
    }
    DataTracker.singleTrackEvent(dataTracker)
    const { enqueueSnackbar } = this.props
    this.props.Search.updateLiteHasData(true)
    this.props.Search.updateLiteListData([])
    Login.logout()
      .then((res: any) => {
        if (res.code * 1 === 0) {
          const { enterpriseId = '' } = Store.get('sessionInfo') || {}
          // 三七互娱不同环境的企业Id
          if (enterpriseIdSqList.includes(enterpriseId)) {
            toLoginOutTo37()
          } else if (enterpriseIdGZList.includes(enterpriseId)) {
            loginOutToManage()
          } else {
            toLogin()
          }
        } else if (+res.code === 3021) {
          Store.set('isOpenPlatform', 0)
          Store.remove('sessionInfo')
          Store.remove('userInfo')
          Store.remove('extra')
          Store.remove('refreshTime')
          Store.remove('isNaturalPerson')
          window.location.href = getCancelUrl() // 调中车注销接口
          return
        } else if (res.code * 1 !== -4) {
          // '请求出错'
          enqueueSnackbar(res.message || transform('error'), {
            variant: 'error',
            autoHideDuration: 2000,
          })
        }
      })
      .catch(err => {
        console.log('error', err)
      })
  }

  private disableSearchBox = () => {
    let disabled = false
    if (
      this.isExamDetailPage() &&
      this.props.ExamStore!.examStage === ExamStage.exam
    ) {
      disabled = true
    }
    return disabled
  }

  private isExamDetailPage = () => {
    return location.href.indexOf('/home/examDetail') > -1
  }

  public render() {
    const { classes, HomeState, UserStore } = this.props
    const hasOrg = Store.get('hasOrg') || false // 是否有企业身份
    const myTopicState =
      UserStore &&
      UserStore.operationList &&
      UserStore.operationList.some(td => +td.id === 84)
    const isShow = HomeState.operationList.includes('OP_CLOUD_SCHOOL_ORDER_APP')
    const data =
      (isPingAn() && [
        DROP_DOWN_LIST[0],
        // '我的报销'  // '我的开班审核'
        { title: transform('my_reimbursement'), value: '3' },
        { title: transform('my_class_audit'), value: '2' },
        DROP_DOWN_LIST[1],
      ]) ||
      DROP_DOWN_LIST

    // 云校身份添加我的订单
    const addData = [{ title: transform('myOrder'), value: '5' }, ...data] // 我的订单

    const myData = (isShow ? addData : data).filter(td => +td.value !== 4)
    if (myTopicState) {
      // '我的知圈'
      myData.splice(1, 0, { title: transform('my_circle'), value: '4' })
    }
    return (
      <div className={classes.root}>
        <AppBar position="static" color="secondary" className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            <Typography className={classes.title} variant="h6" noWrap={true}>
              <div className={classes.logo} onClick={this.goToHomePage} />
            </Typography>
            <div className={classes.grow} />
            {hasOrg && (
              <span>
                <SearchBox
                  history={this.props.history}
                  disabled={this.disableSearchBox()}
                />
              </span>
            )}
            <div
              className={classes.sectionDesktop}
              style={{ width: hasOrg ? '461px' : 'auto' }}
            >
              {hasOrg && (
                <>
                  {
                    HomeState && HomeState.IS_OP_TOB_PAY && (
                      <div onClick={this.toWallet} className={classes.toolsItem}>
                        <span className={classes.packetImg} />
                        {/* 钱包 */}
                        {transform('wallet')}
                      </div>
                    )
                  }
                  <div className={classes.toolsItem} onClick={this.goToMyNews}>
                    <span
                      className={classes.messageImg}
                      data-event-category={DATATREACKER_KEY}
                      // zn-i18n-disable-next-line
                      data-event-label="0103Web-查看消息"
                      data-event-mapkv={JSON.stringify({
                        // zn-i18n-disable-next-line
                        from: '01Web-智门户首页',
                      })}
                    >
                      {HomeState.pushMessage !== 'N' && (
                        <span className={classes.count} />
                      )}
                    </span>
                    {/* 消息 */}
                    {transform('news')}
                  </div>
                </>
              )}
              <div
                aria-owns={this.state.open ? 'material-appbar' : undefined}
                aria-haspopup="true"
                onClick={this.handleProfileMenuOpen}
                style={{ position: 'relative' }}
              >
                <img src={UserStore!.avatar} className={classes.userInfo} />
                <DropDownList
                  style={classes.list}
                  data={myData}
                  open={this.state.open}
                  onChange={value => {
                    switch (value) {
                    case '0':
                      return this.linkMySetting()
                    case '1':
                      return this.logout()
                    case '2':
                      return RouterUtil.toAdmin('training-class-check')
                    case '3':
                      return RouterUtil.toAdmin('my-expense')
                    case '4':
                      return this.goCircle()
                    case '5':
                      return this.goMyOrder()
                    }
                  }}
                  onClose={() => this.setState({ open: false })}
                />
              </div>
              <div className={classes.userName}>{UserStore!.userName}</div>
            </div>
          </Toolbar>
        </AppBar>
      </div>
    )
  }
}

export default withStyles(styles)(withSnackbar(withRouter(PrimarySearchAppBar)))
